import FreightList from './FreightList'

export default FreightList
